import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './StatusBar.module.css';
import Icon from '../Icon';
import Stack from '../Stack';
import Button from '../Button';

const types = ['default', 'information', 'warning', 'error', 'success'];
const bindClasses = classNameBind.bind(styles);

const StatusBar = ({ type, children, dataId, noPadding, text, linkText, linkType, onLinkClick, onClose, closeIcon }) => (
  <div className={bindClasses('wrapper', type, { noChildren: !children, noPadding })} data-ppuc-id={dataId}>
    {
      children
      || (
        <Stack spacing="narrow" verticalAlignment="center">
          <Stack.Item fill />
          {
            ['error', 'warning'].includes(type) && (
            <Icon
              name="exclamation-mark-circle"
              color={type === 'error' ? 'white' : 'default'}
            />
            )
          }
          <Stack.Item fillLight>
            <div className={bindClasses('text', 'cutText')}>{text}</div>
          </Stack.Item>
          {
            linkText && onLinkClick && (
              <Stack.Item previousSpacing={linkType === 'button' ? 'narrow' : 'extraNarrow'}>
                {
                  linkType === 'button'
                    ? <Button size="small" onClick={onLinkClick} text={linkText} minimalWidth />
                    : <span className={bindClasses('link')} onClick={onLinkClick} role="button" tabIndex={0}>{linkText}</span>
                }
              </Stack.Item>
            )
          }
          <Stack.Item fill />
          {
            closeIcon && onClose && (
              <Stack.Item>
                <div className={bindClasses(`${['information', 'error', 'success'].includes(type) ? 'white' : 'default'}-icon`)}>
                  <Button
                    icon="cross"
                    appearance="subdued"
                    onClick={onClose}
                    size="small"
                  />
                </div>
              </Stack.Item>
            )
          }
        </Stack>
      )
    }
  </div>
);

StatusBar.defaultProps = {
  type: 'default',
  dataId: 'StatusBar',
  noPadding: false,
  linkType: 'link',
};

StatusBar.propEnums = {
  type: types,
};

export default StatusBar;
